import { render, staticRenderFns } from "./KontrolaPredSchvalenim.vue?vue&type=template&id=7c6cf1b6&"
import script from "./KontrolaPredSchvalenim.vue?vue&type=script&lang=js&"
export * from "./KontrolaPredSchvalenim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6cf1b6')) {
      api.createRecord('7c6cf1b6', component.options)
    } else {
      api.reload('7c6cf1b6', component.options)
    }
    module.hot.accept("./KontrolaPredSchvalenim.vue?vue&type=template&id=7c6cf1b6&", function () {
      api.rerender('7c6cf1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sumar/KontrolaPredSchvalenim.vue"
export default component.exports